'use client';

import clsx from 'clsx';
import { motion } from 'framer-motion';
import { ArrowDown2 } from 'iconsax-react';
import Select, { DropdownIndicatorProps, Props as SelectProps, components } from 'react-select';
import './style.css';
import { LoadingSpinner } from '@shared/ui';
import { normalizeArabic } from '@shared/lib';

const DropdownIndicator: React.FC<DropdownIndicatorProps> = (props) => {
  const { menuIsOpen, isDisabled } = props.selectProps;

  return (
    <components.DropdownIndicator {...props}>
      <motion.div animate={{ rotate: menuIsOpen ? 180 : 0 }}>
        <ArrowDown2 size={18} className={`${isDisabled ? 'text-disableText' : 'text-text'}`} />
      </motion.div>
    </components.DropdownIndicator>
  );
};

function arabicAwareFilter(option: any, rawInput: string): boolean {
  if (!rawInput || rawInput.trim() === '') return true;

  const input = normalizeArabic(rawInput).toLowerCase();
  const label = normalizeArabic(option.label ?? '').toLowerCase();

  return label.includes(input);
}

export const Dropdown = (props: SelectProps) => {
  return (
    <Select
      menuShouldScrollIntoView={false}
      isRtl
      unstyled
      isSearchable
      filterOption={arabicAwareFilter}
      classNames={{
        control: ({ isFocused, isDisabled }) =>
          clsx(
            'border',
            isFocused ? 'border-blue-1' : 'border border-border',
            'bg-background text-text rounded-md px-[10px] md:px-2.5 md:py-[0.3125rem] h-[34px] md:h-auto hover:border-gray w-[300px] text-[12px] focus:border-blue-1 dark:shadow-dark-100',
            isDisabled ? 'bg-disableBg text-disableText' : ''
          ),
        container: () => 'text-text',
        menu: () => 'bg-modalBg rounded-md shadow-md dark:shadow-dark-100 py-2',
        option: ({ isFocused, isDisabled }) =>
          clsx(
            'p-[8px] !text-[12px]',
            isFocused ? 'bg-hover' : '',
            isDisabled && 'text-disableText'
          ),
        singleValue: ({ isDisabled }) => clsx(isDisabled ? 'text-disableText' : 'text-text'),
        input: ({ isDisabled }) =>
          clsx('text-[12px]', isDisabled ? 'text-disableText' : 'text-text'),
        noOptionsMessage: () => 'h-[25px] flex items-center justify-center',
        placeholder: () => 'text-disableText opacity-[0.8] body-12-regular',
        multiValue: () =>
          'bg-disableBg pl-[2px] pr-[4px] py-[3px] rounded-md border border-border mr-[3px] ml-[3px] mb-[2px] mt-[2px]',
      }}
      noOptionsMessage={() => 'موردی یافت نشد'}
      loadingMessage={() => 'در حال بارگذاری...'}
      components={{
        DropdownIndicator,
        IndicatorSeparator: () => null,
        LoadingIndicator: () => <LoadingSpinner className='text-pics scale-[0.6]' />,
      }}
      {...props}
    />
  );
};
